import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentDynamicPredecisionGet = {
  path: "/consent/dynamic-predecision",
  method: RouteHttpVerb.POST,
  obfuscatePath: "keep-last-part"
};